import { render, staticRenderFns } from "./sessionPathItem.vue?vue&type=template&id=70f066f2&scoped=true"
import script from "./sessionPathItem.vue?vue&type=script&lang=js"
export * from "./sessionPathItem.vue?vue&type=script&lang=js"
import style0 from "./sessionPathItem.vue?vue&type=style&index=0&id=70f066f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f066f2",
  null
  
)

export default component.exports